import KnowledgeGraphList from "./KnowledgeGraphList";

export default KnowledgeGraphList;